import React from 'react';
import CrudTable from '../../components/common/CrudTable';
import { sportTypeAPI } from '../../api/services';

const COLUMNS = [
  { key: 'name', label: 'Name' },
  { key: 'mediaUrl', label: 'Image', render: (item) => item.mediaUrl ? <img src={item.mediaUrl} alt="" style={{ width: 48, height: 32, objectFit: 'cover', borderRadius: 6 }} /> : '—' },
  { key: 'createdAt', label: 'Created', render: (item) => item.createdAt?.substring(0, 10) || '—' },
];

const FORM_FIELDS = [
  { name: 'name', label: 'Sport Type Name', placeholder: 'e.g. Football' },
  { name: 'mediaId', label: 'Sport Type Image', type: 'file' },
];

const SportTypesAdmin = () => (
  <CrudTable
    title="Sport Types"
    entityName="Sport Type"
    columns={COLUMNS}
    formFields={FORM_FIELDS}
    fetchData={async () => {
      const res = await sportTypeAPI.getAll();
      return res.data?.data || [];
    }}
    onAdd={(data) => sportTypeAPI.add(data)}
    onUpdate={(id, data) => sportTypeAPI.update(id, data)}
    onDelete={(id) => sportTypeAPI.delete(id)}
  />
);

export default SportTypesAdmin;
